module.exports = __webpack_public_path__ + "img/header-shape.65d035f2.png";